export default __webpack_public_path__ + "static/media/project_custom.85ae5073.WebP";